import { useQuery } from "@tanstack/react-query";
import { getParcours } from "../api/parcoursApi";
import { queryKeys } from "../lib/queryKeys";

export function useParcoursDetail(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.parcours.detail(id ?? ""),
    queryFn: () => getParcours(id as string),
    enabled: Boolean(id),
  });
}
